import * as React from 'react';
import { createPortal } from 'react-dom';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import { RoundButton } from '../../RoundButton';

import * as styles from './FullscreenControls.css';

export type TDirection = '>' | '<';

export interface IFullscreenControlsProps {
  onControlClick(direction: TDirection): void;
}

export function FullscreenControls({ onControlClick }: IFullscreenControlsProps) {
  return createPortal(
    <div data-name="FullscreenControls" className={styles['container']}>
      <RoundButton buttonStyles={styles['left_arrow']} onClick={() => onControlClick('<')}>
        <IconActionChevronLeft16 color="icon-on-bright-default" />
      </RoundButton>

      <RoundButton buttonStyles={styles['right_arrow']} onClick={() => onControlClick('>')}>
        <IconActionChevronRight16 color="icon-on-bright-default" />
      </RoundButton>
    </div>,
    document.body,
  );
}
